export function Badge({ tone = 'muted', children, className = '' }) {
  const map = {
    ok: 'badge-ok',
    warn: 'badge-warn',
    danger: 'badge-danger',
    muted: 'badge-muted',
  };
  return <span className={`badge ${map[tone] || map.muted} ${className}`}>{children}</span>;
}
